import { Text } from '@mantine/core';

import { InstPage, Integration } from '../../../../types';

const INTEGRATION_BADGES: Record<Integration, string> = {
  umnico: 'UM',
  instagram: 'IG',
  'facebook-messenger': 'FM',
  'instagram-connect': 'IC',
};

const INTEGRATION_LABELS: Record<Integration, string> = {
  umnico: 'Umnico',
  instagram: 'Instagram',
  'facebook-messenger': 'Facebook Messenger',
  'instagram-connect': 'Instagram Connect',
};

/**
 * Read-only channel marker. The integration is a property of the Meta asset the page was added
 * from, so it is never switchable here — a page added as Facebook Messenger cannot become an
 * Instagram one. Only the FB token can be refreshed (see `RefreshToken`).
 */
export const InstIntegration = ({ page }: { page: InstPage }) => {
  const integration = page.integration ?? 'umnico';

  return (
    <Text size="sm" opacity={0.8} title={INTEGRATION_LABELS[integration]}>
      {INTEGRATION_BADGES[integration]}
    </Text>
  );
};
